export default __webpack_public_path__ + "static/media/gallery_06.bf74ebc6.jpg";